import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { client } from "../../../../App";
import {
  DELETE_USER,
  getEvictionForMutation,
} from "../../../../helpers/mutations";
import { useTranslation } from "react-i18next";
import Modal from "../../../common/Modal/Modal";
import { handlerErrors } from "../../../../helpers/helpers";
import { useSelector } from "react-redux";
import "./DeleteUserBotton.scss";

function DeleteUserButton() {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [clickedDeleteButton, setclickedDeleteButton] = useState(false);
  const { t } = useTranslation();
  const [, setGenericError] = useState(null);
  const [isError, setisError] = useState(false);
  const state = useSelector((state) => state);

  function deleteUser(deleteUserMutation) {
    return new Promise((resolve) =>
      deleteUserMutation()
        .then(resolve)
        .catch((err) => {
          setisError(true);
          setclickedDeleteButton(false);
          setShow(false);
          setShowError(true);
          handlerErrors(err, setGenericError, setGenericError);
        })
    );
  }
  useEffect(() => {
    if (clickedDeleteButton) {
      const deleteUserMutation = async () =>
        client().mutate({
          mutation: DELETE_USER,
          update: (cache) => {
            const fieldsToEvict = getEvictionForMutation("deleteUser");
            fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
            cache.gc();
          },
        });
      deleteUser(deleteUserMutation).then(() => {
        if (!isError && clickedDeleteButton) {
          history.push("/logout");
        }
      });
    }
  });
  return (
    state.auth &&
    state.auth.user && (
      <>
        <div
          className="row"
          style={{ borderTop: "1px solid rgba(0, 0, 0, 0.125)" }}
        ></div>
        <div className="col-sm-12 col-md-10 offset-md-1">
          <div className="delete-account--container row">
            <div className="delete-account--text">
              <h2 className="delete-account--title headline-bold-fs4">
                {t("delete.user.button.title")}
              </h2>
              <p className="delete-account--description paragraph-large-fs7">
                {t("delete.user.button.subtitle")}
              </p>
            </div>
            <button
              type="button"
              className="btn btn-secondary btn-transparent"
              onClick={() => setShow(true)}
            >
              {t("delete.user.button.cta")}
            </button>
          </div>
        </div>
        <Modal
          show={show}
          onClose={() => setShow(false)}
          icon={"gc-icon-functional-question-2-col"}
          description={t("account.deletion.popup.description")}
          type={"button"}
          styleType={"secondary"}
          onFirstClick={() => setShow(false)}
          linkTitle={t("account.deletion.popup.cancel")}
          typeSecond={"button"}
          styleTypeSecond={"primary"}
          onSecondClick={() => setclickedDeleteButton(true)}
          linkTitleSecond={t("account.deletion.popup.confirm")}
        />
        <Modal
          show={showError}
          onClose={() => setShowError(false)}
          description={t("account.deletion.error.text")}
        />
      </>
    )
  );
}
export default DeleteUserButton;
